export const responseExamples = {
  GetIpData: (
    <pre>
      ip: "184.181.109.162", <br />
      reverse: "ip184-181-109-162.oc.oc.cox.net", <br />
      continent_code: "NA", <br />
      continent_name: "North America", <br />
      country_code: "US", <br />
      country_name: "United States", <br />
      region_name: "California", <br />
      city: "Palos Verdes Estates", <br />
      calling_code: "1", <br />
      postal_code: "90274", <br />
      time_zone: {"{"} <br />
      name: "America/Los_Angeles", <br />
      abbr: "PDT", <br />
      offset: "-0700", <br />
      is_dst: true, <br />
      current_time: "2023-07-06T08:32:45-07:00", <br />
      {"{"}, <br />
      location: "33.767101287842, -118.38140106201", <br />
      is_eu: false, <br />
      languages: [{"{"} name: "English", native: "English", code: "en" {"}"}],{" "}
      <br />
      currency: {"{"} <br />
      name: "US Dollar", <br />
      code: "USD", <br />
      symbol: "$", <br />
      native: "$", <br />
      plural: "US dollars", <br />
      {"}"}, <br />
      isp: "Cox Communications Inc.", <br />
      asn: "AS22773", <br />
      mobile: false, <br />
      hosting: false, <br />
      anonymous: false, <br />
      known_attacker: false, <br />
      known_abuser: false, <br />
      threat: false, <br />
      bogon: false, <br />
    </pre>
  ),
  GetBalance: (
    <pre>
      {"{"} <br />
      "balance": 80.95 <br />
      {"}"}
    </pre>
  ),
  GetRequestsLeft: (
    <pre>
      {"{"} <br />
      "requests": 1026 <br />
      {"}"}
    </pre>
  ),
  GetSubscriptions: (
    <pre>
      {"{"} <br />
      "id": 4, <br />
      "product_name": "Professional", <br />
      "requests_left": 2924, <br />
      "date_start": "2023-10-07", <br />
      "date_end": "2023-11-07", <br />
      "requests": "3000" <br />
      {"}"}
    </pre>
  ),
};
